import { ExtendedPricesWizardData } from '../components/PricesWizard/Controls/PricesWizardExtended/PricesWizardExtended';
import { SimplePricesWizardData } from '../components/PricesWizard/Controls/PricesWizardSimple/PricesWizardSimple';

import { CampaignPlatform, CampaignType } from './domain';

export enum PricesWizardType {
    simple = 0,
    extended = 1
}

export interface PhrasesFeaturesData {
    commonPlatform: CampaignPlatform[];
    commonCampaignType: CampaignType[];
}

export interface PricesWizardData {
    isSaveInProgress: boolean;
    error?: string;
    contextData?: PhrasesFeaturesData;
    wizardType: PricesWizardType;
    simple: SimplePricesWizardData;
    extended: ExtendedPricesWizardData;
}
